
import React from 'react';

const b2bStyle = {
  backgroundColor: '#01B48F',
  width: 46,
  height: 30,
  display: 'inline-block',
  color: '#F5F7F9',
  borderRadius: 3,
  textAlign: 'center',
  fontSize: 12,
  fontWeight: 500,
  textTransform: 'uppercase',
  padding: 7
}

const b2bSVG = () =>
  <span style={b2bStyle}>
    b2b
  </span>;


export default b2bSVG;


// WEBPACK FOOTER //
// ./src/svg/b2bSVG.js